"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCustomFonts;
Object.defineProperty(exports, "TOOLBAR_BUTTON_CUSTOM_FONTS", {
  enumerable: true,
  get: function get() {
    return _customFonts.TOOLBAR_BUTTON_CUSTOM_FONTS;
  }
});

var _react = require("react");

var _useBunnyFonts = _interopRequireDefault(require("./useBunnyFonts"));

var _fonts = require("./fonts");

var _debounce = _interopRequireDefault(require("./debounce"));

var _customFonts = require("./plugins/customFonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useFonts = (content, extraFonts) => {
  var [contentFonts, setContentFonts] = (0, _react.useState)((0, _fonts.getFontsFromContent)(content));
  var updateFontsFromContent = (0, _react.useCallback)((0, _debounce.default)(data => {
    var newFonts = (0, _fonts.getFontsFromContent)(data);

    if (newFonts.length !== contentFonts.length || !newFonts.every(f => contentFonts.indexOf(f) >= 0)) {
      setContentFonts(newFonts);
    }
  }, 1000), [contentFonts]);
  (0, _react.useEffect)(() => {
    updateFontsFromContent(content);
  }, [content]);
  var fontsToLoad = (0, _react.useMemo)(() => [...new Set([...extraFonts, ..._fonts.DEFAULT_FONTS, ...contentFonts])], [extraFonts, contentFonts]);
  (0, _useBunnyFonts.default)(fontsToLoad);
  var fontsList = (0, _react.useMemo)(() => {
    var fonts = [...new Set([...extraFonts, ..._fonts.DEFAULT_FONTS])].sort().reduce((prev, next) => _objectSpread(_objectSpread({}, prev), {}, {
      [next]: next
    }), {});
    return _objectSpread(_objectSpread({}, _fonts.DEFAULT_FONT_OPTIONS), fonts);
  }, [extraFonts]);
  return {
    fontsList
  };
};
/**
 * Load Fonts and configure Jodit with the custom font picker
 *
 * @param {object} config The Jodit config that is being extended
 * @param {string} content The current content of the editor, which is used to
 *   restore previously loaded fonts
 * @param {string[]} customFonts Any custom fonts that should be loaded by default
 * @param {string} moreFontsLabel The label for the More Fonts option
 * @param {() => void} onAddFonts The callback for the More Fonts option
 * @example
 * ```
 * conf = useCustomFonts(conf, content, [], 'More Fonts', () => alert('Show dialog'));
 * ```
 */


function useCustomFonts(config, content, customFonts, moreFontsLabel, onAddFonts) {
  var {
    fontsList
  } = useFonts(content, customFonts); // Return a config entry for the control

  var updatedConfig = (0, _react.useMemo)(() => _objectSpread(_objectSpread({}, config || {}), {}, {
    customFonts: {
      moreFontsLabel,
      onAddFonts
    },
    controls: _objectSpread(_objectSpread({}, (config === null || config === void 0 ? void 0 : config.controls) || {}), {}, {
      [_customFonts.TOOLBAR_BUTTON_CUSTOM_FONTS]: {
        list: fontsList
      }
    })
  }), [config, fontsList]);
  return updatedConfig;
}